/* Detail Accordion — Fotorecord
   I summary degli accordion chiusi SONO il riepilogo della configurazione (dall'11/09/2026,
   quando la tabella sopra il prezzo e' stata tolta): a destra del titolo, la selezione
   corrente con quanto pesa nel prezzo — «— Vetro normale (+ € 4,04)» — oppure «nessuno»
   in rosso se il componente non c'e'. Gli accordion NON si aprono da soli: un riepilogo
   che si spalanca a ogni clic non e' un riepilogo. Il cliente apre quello che vuole leggere.

   Due sorgenti, due eventi:
   · la selezione arriva dall'evento della sezione (data-det-event, es. casm:fronte-selected)
     e dalla variabile globale di init (data-det-init, es. _CASM_FRONTE);
   · gli importi arrivano da `fotorecord:prezzi-componenti` (ConfiguratoreBase
     ._publishPrezziComponenti: addendi del motore, IVA inclusa, mai ricalcolati qui) e
     da window._FOTORECORD_PREZZI_COMPONENTI per l'init. La chiave del componente si
     deriva dal suffisso dell'evento della sezione, cosi' nessun template deve dichiararla. */

/* suffisso dell'evento di sezione → chiave nell'oggetto prezzi */
var CHIAVE_PREZZO = {
  'cornice-selected':     'profilo',
  'fronte-selected':      'fronte',
  'retro-selected':       'retro',
  'pass-cartone-changed': 'passCartone',
  'pass-legno-changed':   'passLegno',
  'stampa-changed':       'stampa',
  'accessori-changed':    'accessori',
  'clip-changed':         'accessori'
};

function chiavePrezzo(eventName) {
  var suffix = String(eventName || '').split(':').pop();
  return CHIAVE_PREZZO[suffix] || '';
}

/* Stesso formato di ConfiguratoreBase._fmt: virgola decimale, punto per le migliaia. */
function fmtEuro(n) {
  // Il formatter e' uno per tutti (configuratore-core.js, FOTORECORD.fmtEuro); il ripiego
  // identico serve solo se questo file gira senza il core (pagina senza configuratore).
  if (window.FOTORECORD && window.FOTORECORD.fmtEuro) return window.FOTORECORD.fmtEuro(n);
  return '€ ' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/* «Nessuno» ha piu' forme: payload nullo (passepartout, stampa, cornice assente), l'opzione
   «Nessuno» di fronte/retro (sku vuoto, e' una riga sintetica del configuratore) e le
   attaccaglie a quantita' zero. */
function isNessuno(detail) {
  if (!detail) return true;
  if (!detail.sku && /^nessun/i.test(detail.nome || '')) return true;
  if (detail.tipo === 'attaccaglia' && !detail.totQty) return true;
  return false;
}

function getSummary(detail, chiave) {
  var core = window.FOTORECORD && window.FOTORECORD.core;
  /* Il profilo si riconosce dal codice, com'e' ovunque in vetrina (FRAS0020): il suo
     `nome` e' il titolo prodotto, lungo una riga. */
  if (chiave === 'profilo' && detail.sku && core && core.toIdDb && core.pubblico) {
    return core.pubblico(core.toIdDb(detail.sku));
  }
  var nome = (typeof detail.nome === 'string') ? detail.nome : '';
  /* Quantita' + nome: «4 × Attaccaglie snodate ottonate 10×20 mm» ripete nel riepilogo cio'
     che il titolo dell'accordion («Accessori», «Clip») dice gia'; e se le attaccaglie sono
     di due tipi il nome del primo e' pure incompleto. Il riepilogo dice il conto e il genere
     — «4 attaccaglie», «4 clip» — e il dettaglio sta nell'accordion aperto, che e' il suo
     posto (controllo-sito 13/09, I2). Un nome che non e' un'attaccaglia (es. un gancio
     scelto da solo) resta intero: li' il nome E' l'informazione.
     Le clip sono una sola voce per configuratore e il loro `nome` in metaobject e' un
     «Attaccaglie montature a giorno» / «Attaccaglie pannelli solo vetro» (db_costi_fissi,
     forma=clip): il conto basta, il genere lo dice gia' il titolo dell'accordion. */
  if (detail.tipo === 'clip' && detail.clipQty != null) {
    return detail.clipQty + ' clip';
  }
  if (detail.tipo === 'attaccaglia' && detail.totQty != null) {
    var scelti = Array.isArray(detail.items) ? detail.items.filter(function (i) { return i.qty > 0; }) : [];
    if (scelti.length > 1) {
      var tutteAttaccaglie = scelti.every(function (i) { return /^attaccagli/i.test(i.nome || ''); });
      return detail.totQty + (tutteAttaccaglie ? ' attaccaglie' : ' accessori');
    }
    if (/^attaccagli/i.test(nome)) return detail.totQty + ' attaccaglie';
    return detail.totQty + ' × ' + nome;
  }
  /* Lastre, passepartout, stampa: nome + codice pubblico, come nella scheda aperta
     (codice_prodotto.nome_cliente, 15/09/2026). */
  if (detail.sku && core && core.nomeCliente) return core.nomeCliente(detail.nomeBreve || nome, core.toIdDb ? core.toIdDb(detail.sku) : detail.sku);
  return nome;
}

document.querySelectorAll('.det-section').forEach(function (root) {
  if (root.dataset.detAccordionBound) return;

  var disc      = root.querySelector('.det-disclosure');
  var summVal   = root.querySelector('.det-summary__value');
  var eventName = root.dataset.detEvent;
  var initKey   = root.dataset.detInit;
  /* Marchiamo solo dopo aver trovato il disclosure: i root senza (accordion statici che
     riusano .det-section per lo stile) non hanno nulla da legare e restano marcabili. */
  if (!disc || !summVal || !eventName) return;
  root.dataset.detAccordionBound = '1';

  var chiave = chiavePrezzo(eventName);
  /* Lo span del prezzo sta FUORI da .det-summary__value, che tronca con l'ellipsis: il
     nome puo' accorciarsi, l'importo no. */
  var prezzoEl = document.createElement('span');
  prezzoEl.className = 'det-summary__prezzo';
  summVal.insertAdjacentElement('afterend', prezzoEl);

  var selezione = undefined;   // undefined = ancora nessun evento; null = «nessuno»
  var prezzi    = window._FOTORECORD_PREZZI_COMPONENTI;

  function render() {
    if (selezione === undefined) { summVal.textContent = ''; prezzoEl.textContent = ''; return; }
    if (isNessuno(selezione)) {
      summVal.textContent = '— nessuno';
      summVal.classList.add('det-summary__value--nessuno');
      prezzoEl.textContent = '';
      return;
    }
    summVal.classList.remove('det-summary__value--nessuno');
    var text = getSummary(selezione, chiave);
    summVal.textContent = text ? '— ' + text : '';
    var importo = (prezzi && chiave) ? prezzi[chiave] : null;
    prezzoEl.textContent = (typeof importo === 'number' && importo > 0) ? '(+ ' + fmtEuro(importo) + ')' : '';
  }

  document.addEventListener(eventName, function (e) {
    selezione = (e.detail === undefined) ? null : e.detail;
    render();
  });
  document.addEventListener('fotorecord:prezzi-componenti', function (e) {
    prezzi = e.detail;
    render();
  });

  /* Init: legge le variabili globali gia' pubblicate dal configuratore (il modulo puo'
     partire dopo il primo giro di eventi). `undefined` = il configuratore non ha ancora
     parlato di questo componente: si resta vuoti, non si inventa un «nessuno». */
  setTimeout(function () {
    if (initKey && window[initKey] !== undefined) {
      selezione = window[initKey];
      prezzi    = window._FOTORECORD_PREZZI_COMPONENTI;
      render();
    }
  }, 0);
});
